/**
 * Use before any destructive remove/delete (API DELETE, permanent data loss).
 * @param {string} [message] - Specific question; defaults to generic delete warning.
 * @returns {boolean} true if user confirmed
 */
export function confirmDelete(
  message = 'Are you sure you want to delete this? This action cannot be undone.'
) {
  return window.confirm(message);
}
